// src/components/Experience/Experience.jsx
import React from "react";
import ADJ from "../../assets/ADJ_logo.webp";
import JBL from "../../assets/JBL_logo.webp";
import MACKIE from "../../assets/Mackie_logo2.webp";
import PRESONUS from "../../assets/Presonus_logo.webp";
import DBLOGO from "../../assets/db_logo.webp";
import CHAUVET from "../../assets/chauvet_logo.webp";
import PropTypes from "prop-types"; // Lisää tämä ylös muiden importien joukkoon

const Experience = () => {
  return (
    <section
      className="container font-customFont1 flex flex-col p-6 shadow-lg bg-white bg-opacity-80 dark:bg-violet dark:bg-opacity-80"
      aria-labelledby="tuotemerkit-otsikko"
    >
      <h2 id="tuotemerkit-otsikko" className="sr-only">Tuotemerkit</h2>

      <div data-aos="fade-in" title="Näitä tuotemerkkejä käytämme">
        <h3 className="font-customFont2 dark:text-shadow-xxl text-left text-darkest dark:text-primary xxxsm:text-4xl text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight mb-6">
          Tuotemerkit
        </h3>

        <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light mb-8">
          Käytämme tapahtumissa vain huippumerkkejä, jotka takaavat laadun, luotettavuuden ja upean äänentoiston sekä visuaalisuuden. Luotamme laitteisiin, jotka kestävät kovan keikkakäytön ja mahdollistavat teknisesti saumattoman kokemuksen.
        </p>

        <div className="flex flex-wrap justify-center gap-6">
          <LogoItem href="https://www.presonus.com/en/start" alt="PreSonus logo" src={PRESONUS} />
          <LogoItem href="https://www.adj.eu/" alt="ADJ logo" src={ADJ} />
          <LogoItem href="https://www.chauvetprofessional.com/" alt="Chauvet logo" src={CHAUVET} />
          <LogoItem href="https://fi.jbl.com/" alt="JBL logo" src={JBL} />
          <LogoItem href="https://mackie.com/" alt="Mackie logo" src={MACKIE} />
          <LogoItem href="https://www.dbtechnologies.com/en/home/" alt="dB Technologies logo" src={DBLOGO} />
        </div>
      </div>
    </section>
  );
};

// Erillinen komponentti logoja varten
const LogoItem = ({ href, alt, src }) => (
  <div className="bg-dark/40 p-3 hover:scale-105 transition duration-300 border border-transparent hover:border-primary dark:hover:border-white">
    <a href={href} target="_blank" rel="noopener noreferrer" title={alt}>
      <img
        src={src}
        alt={alt}
        className="h-12 md:h-14 xl:h-16 object-contain"
        loading="lazy"
      />
    </a>
  </div>
);

LogoItem.propTypes = {
  href: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
};

export default Experience;
